// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"00376b2f","299":"3fd67a49","544":"7ffe3c92","997":"9cd4f44b"}[chunkId] + ".chunk.js";
};